'use client'

import { useRouter } from 'next/navigation'
import { useTranslations } from 'next-intl'

import { MButton } from '@/_components/medante/ui/m-button'
import { pushPathWithHash } from '@/_lib/next-link-href'

function AJobsSectionShowJobs() {
	const router = useRouter()
	const t = useTranslations('pages.letsMakeWorldHealthier.showJobs')

	return (
		<div className='wrapper2 pb-6 md:text-center'>
			<MButton
				variant='purple'
				onClick={() => {
					pushPathWithHash(router, '/kariera#pozicie')
				}}
			>
				{t('showJobs')}
			</MButton>
		</div>
	)
}

export default AJobsSectionShowJobs
